module.exports = __webpack_public_path__ + "static/image5-e2f5b67c617fa825bf4571d502f7091e.jpg";